var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "contractForm",
      staticStyle: { width: "100%", "text-align": "left" },
      attrs: {
        model: _vm.contractForm,
        rules: _vm.contractRules,
        size: "small",
        "label-width": "100px",
        "label-position": "left",
      },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "订单类型", prop: "orderType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择订单类型" },
                      on: { change: _vm.getContractNumber },
                      model: {
                        value: _vm.contractForm.orderType,
                        callback: function ($$v) {
                          _vm.$set(_vm.contractForm, "orderType", $$v)
                        },
                        expression: "contractForm.orderType",
                      },
                    },
                    _vm._l(_vm.dict.order_type, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "合同类型", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "请选择合同类型" },
                      model: {
                        value: _vm.contractForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.contractForm, "type", $$v)
                        },
                        expression: "contractForm.type",
                      },
                    },
                    _vm._l(_vm.dict.contract_type, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "合同号", prop: "contractNo" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入合同号" },
                    model: {
                      value: _vm.contractForm.contractNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.contractForm, "contractNo", $$v)
                      },
                      expression: "contractForm.contractNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "订单管理号", prop: "orderNo" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入订单管理号" },
                    model: {
                      value: _vm.contractForm.orderNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.contractForm, "orderNo", $$v)
                      },
                      expression: "contractForm.orderNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "客户姓名", prop: "customerName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户姓名" },
                    model: {
                      value: _vm.contractForm.customerName,
                      callback: function ($$v) {
                        _vm.$set(_vm.contractForm, "customerName", $$v)
                      },
                      expression: "contractForm.customerName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "客户电话", prop: "customerPhone" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户电话" },
                    model: {
                      value: _vm.contractForm.customerPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.contractForm, "customerPhone", $$v)
                      },
                      expression: "contractForm.customerPhone",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户地址", prop: "address" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户地址" },
                    model: {
                      value: _vm.contractForm.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.contractForm, "address", $$v)
                      },
                      expression: "contractForm.address",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "合同金额", prop: "contractAmount" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入合同金额" },
                    model: {
                      value: _vm.contractForm.contractAmount,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.contractForm,
                          "contractAmount",
                          _vm._n($$v)
                        )
                      },
                      expression: "contractForm.contractAmount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "预算金额", prop: "budgetAmount" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入预算金额" },
                    model: {
                      value: _vm.contractForm.budgetAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.contractForm, "budgetAmount", _vm._n($$v))
                      },
                      expression: "contractForm.budgetAmount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "合同签订时间", prop: "contractTime" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: { type: "datetime", placeholder: "选择日期时间" },
                    model: {
                      value: _vm.contractForm.contractTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.contractForm, "contractTime", $$v)
                      },
                      expression: "contractForm.contractTime",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "合同图片" } },
                [
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        action: _vm.filesUploadApi,
                        "list-type": "picture-card",
                        multiple: "",
                        headers: _vm.headers,
                        "file-list": _vm.contractForm.images,
                        "on-success": _vm.handleImageUploadSuccess,
                        "on-remove": _vm.handleImageRemove,
                        "auto-upload": true,
                        limit: 10,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "file",
                          fn: function (ref) {
                            var file = ref.file
                            return _c("div", {}, [
                              _c("img", {
                                staticClass: "el-upload-list__item-thumbnail",
                                attrs: { src: file.url, alt: "" },
                              }),
                            ])
                          },
                        },
                      ]),
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-plus",
                        attrs: { slot: "default" },
                        slot: "default",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "附件" } },
                [
                  _c("oss-upload", {
                    ref: "ossFileUpload",
                    attrs: {
                      "upload-type": "file",
                      multiple: true,
                      accept: ".pdf,.zip,.rar,.7z,.doc,.docx,.xls,.xlsx",
                      "oss-dir": "crm/contract/file/",
                    },
                    on: {
                      "upload-success": _vm.handleFileUploadSuccess,
                      "delete-success": _vm.handleFileDeleteSuccess,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", placeholder: "请输入备注" },
                    model: {
                      value: _vm.contractForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.contractForm, "remark", $$v)
                      },
                      expression: "contractForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }